import React from 'react';

import {CartNotificationImpressionEvent, CartNotification} from '@udemy/cart';
import {Tracker, TrackImpression} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {IconButton} from '@udemy/react-core-components';
import {safelySetInnerHTML} from '@udemy/shared-utils';

import styles from './styles.module.less';

interface NotificationProps {
    notification: CartNotification;
    onRemove(): void;
}

export const Notification: React.FC<NotificationProps> = ({notification, onRemove}) => {
    const {gettext} = useI18n();
    const level = notification.options.level ?? 'info';

    function trackImpression() {
        Tracker.publishEvent(
            new CartNotificationImpressionEvent(
                notification.message,
                notification.options.reason,
                'udlite',
            ),
        );
    }

    return (
        <TrackImpression trackFunc={trackImpression}>
            <div className={styles.notification}>
                <div>
                    <Icon
                        glyph={level}
                        className={styles['info-icon']}
                        color="neutral"
                        label={false}
                    />
                    <span
                        {...safelySetInnerHTML({
                            descriptionOfCaller: 'notifications:message',
                            html: notification.message,
                        })}
                    />
                </div>
                <IconButton
                    className={styles['close-button']}
                    udStyle="ghost"
                    size="small"
                    onClick={onRemove}
                >
                    <Icon glyph="close" color="neutral" label={gettext('Close')} />
                </IconButton>
            </div>
        </TrackImpression>
    );
};
